import {roomsToConfigurationObject} from '@daedalus/core/src/room/business/roomConfiguration'

const getRoomConfig = params => {
  return roomsToConfigurationObject(params.rooms)
}

export default getRoomConfig
